'use strict';

var angular = require('angular');
var _ = require('lodash');
var PaxGridDirective = function PaxGridDirective($timeout) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/pax-grid.html'),
    controller: 'PaxGridController',
    scope: {
      gridId: '@',
      gridColorId: '@',
      title: '@',
      selectable: '=',
      brushFilterType: '@',
      maxRows: '=',
      maxHeight: '=',
      isStriped: '=',
      resetButton: '=',
      rowSpanField: '@',
      dynamicColors: '=',
      screen: '@',
      mode: '@',
      filterFields: '=',
      brushFilterChanged: '=',
      hideEmptyColumns: '=',
      "class": '@'
    },
    link: function link(scope, element) {
      var tablePlaceholder = element.find('.table-placeholder');
      var template = _.template(require('../templates/pax-grid-table.html'));
      var tooltipContentTemplate = _.template(require('../templates/pax-tooltip.html'));
      var resizeHandler = _.throttle(function () {
        var colWidth = element.find('table.rm-pax-table-body tbody tr:first').children().map(function () {
          return this.offsetWidth;
        });
        var headerCellsWithoutLast = element.find('table.rm-pax-table-header thead tr').children().slice(0, -1);
        headerCellsWithoutLast.each(function (i, v) {
          v.style.width = '' + colWidth[i] + 'px';
        });
      }, 50);
      function setScrollableClass() {
        scope.scrollable = 'scrollable';
      }
      function setNotScrollableClass() {
        if (scope.gridId === 'service-opportunities') {
          scope.scrollable = 'not-scrollable';
        }
      }
      function setMaxHeight() {
        var scrollBox = element.find('.scroll-box');
        if (scope.maxRows > 0) {
          scrollBox.css({
            height: element.find('table.rm-pax-table-body tbody tr:first').height() * scope.maxRows + scope.maxRows - 1
          });
        } else if (scope.maxHeight > 0) {
          scrollBox.css({
            height: scope.maxHeight - element.find('.rm-pax-table-header').height()
          });
        }
      }
      function adjustHeader() {
        window.addEventListener('resize', resizeHandler);
        $timeout(resizeHandler);
      }
      scope.render = function () {
        var html = template(scope);
        destroyPopovers(); //prevents potential memory leaks on rerender
        tablePlaceholder.html(html);
        if (scope.isScrollable()) {
          setScrollableClass();
          adjustHeader();
          setMaxHeight();
        } else {
          setNotScrollableClass();
        }
        initPopovers();
      };
      if (scope.selectable) {
        element.on('click', 'tr>td:first-child', function (event) {
          var rowIndex = angular.element(event.currentTarget).parent().prevAll().length;
          scope.selectionByRow(rowIndex, event.ctrlKey, event.shiftKey);
        });
        element.on('click', 'th', function (event) {
          var columnIndex = angular.element(event.currentTarget).prevAll().length;
          if (columnIndex !== 0) {
            scope.selectionByColumn(columnIndex, event.ctrlKey, event.shiftKey);
          }
        });
      }
      function highlightBySelectedColumns(rows, columns, selectionValues, trElements) {
        var indexes = [0];
        _.forEach(columns, function (column, index) {
          if (selectionValues.indexOf(column.label) !== -1) {
            indexes.push(index);
          }
        });
        for (var n = 0; n < rows.length; n++) {
          var row = rows[n];
          var isPrevCellSelected = false;
          var trElement = trElements.eq(n);
          var tdElements = trElement.children();
          for (var i = row.length - 1; i > 0; i--) {
            var tdElement = tdElements.eq(i);
            var classNames = [];
            var selected = indexes.indexOf(i) !== -1;
            if (!selected) {
              classNames.push('not-selected-cell');
            }
            if (!isPrevCellSelected && selected || isPrevCellSelected && !selected) {
              classNames.push('right-border');
            }
            tdElement.prop('className', classNames.join(' '));
            isPrevCellSelected = selected;
          }
          var firstCell = tdElements.eq(0);
          firstCell.prop('className', isPrevCellSelected ? 'right-border' : '');
          if (scope.selectable) {
            firstCell.addClass('selectable');
          }
        }
      }
      function highlightBySelectedRows(rows, selectionValues, trElements) {
        var prevSelectedRow = false;
        for (var n = rows.length - 1; n >= 0; n--) {
          var row = rows[n];
          var classNames = [];
          var selected = selectionValues.indexOf(row[0].value) !== -1;
          if (!selected) {
            classNames.push('not-selected-cell');
          }
          if (!prevSelectedRow && selected || prevSelectedRow && !selected) {
            classNames.push('bottom-border');
          }
          var trElement = trElements.eq(n);
          var classNameProp = classNames.join(' ');
          var children = trElement.children();
          children.prop('className', classNameProp);
          if (scope.selectable) {
            children.first().addClass('selectable');
          }
          prevSelectedRow = selected;
        }
      }
      function initPopovers() {
        tablePlaceholder.on('mouseenter', 'td', function () {
          var $this = angular.element(this);
          var tooltipData = getTooltipData($this.attr('row-index'), $this.attr('cell-index'));
          if (!_.isUndefined(tooltipData)) {
            tooltipData.gridId = scope.gridId;
            $this.popover({
              content: function content() {
                return tooltipContentTemplate(tooltipData);
              },
              html: true,
              placement: 'top',
              container: 'body'
            });
            $this.popover('show');
          }
        });
        tablePlaceholder.on('mouseleave', 'td', function () {
          angular.element(this).popover('hide');
        });
      }
      function destroyPopovers() {
        tablePlaceholder.find('td').popover('destroy');
      }
      function getTooltipData(rowIndex, cellIndex) {
        return scope.rows[rowIndex][cellIndex].tooltip;
      }
      scope.resetSelection = function () {
        var trElements = element.find('tbody').children();
        var children = trElements.children();
        children.prop('class', '');
        if (scope.selectable) {
          children.filter(':first-child').prop('class', 'selectable');
        }
      };
      scope.highlightCells = function (rows, isRowSelection, columns, selectionValues) {
        var trElements = element.find('tbody').children();
        if (isRowSelection) {
          highlightBySelectedRows(rows, selectionValues, trElements);
        } else {
          highlightBySelectedColumns(rows, columns, selectionValues, trElements);
        }
      };
      scope.isScrollable = function () {
        return scope.maxRows > 0 && scope.rows.length > scope.maxRows || scope.maxHeight > 0;
      };
      scope.$on('$destroy', function () {
        window.removeEventListener('resize', resizeHandler);
        destroyPopovers();
      });
    }
  };
};
PaxGridDirective.$inject = ['$timeout'];
module.exports = PaxGridDirective;